import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (type === 'number' && e.target.value) {
        // Remove leading zeros while preserving decimal numbers
        const value = e.target.value.replace(/^0+(?=\d)/, '');
        e.target.value = value;
      }
      onChange?.(e);
    };

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-[#4b5563] bg-[#1e293b] px-3 py-2 text-base",
          "ring-offset-background",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground",
          "hover:bg-[#243447] hover:border-[#60a5fa]",
          "focus-visible:outline-none focus-visible:border-[#60a5fa] focus-visible:border-2 focus-visible:ring-1 focus-visible:ring-[#60a5fa]/20 focus-visible:ring-offset-1",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "transition-colors duration-200",
          "md:text-sm",
          className
        )}
        onChange={handleChange}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
